import { Card, CardContent, IconButton, Stack, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { BinIcon, EditIcon, InfiniteIcon } from '@tom-ui/ui'
import { EquipmentTypes } from '@yard/app/api'
import { YardNodeHeaderTitle } from '../atoms/YardNodeHeaderTitle'
import { YardNodeHeaderEquipmentType } from './YardNode/YardNodeHeaderEquipmentType'

interface Props {
  id: string
  name: string
  equipmentTypes: EquipmentTypes[]
  focused: boolean
  isEditable: boolean
  hasOccupancies: boolean
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}
export const FlexibleBlockHeader = ({
  name,
  equipmentTypes,
  focused,
  isEditable,
  id,
  hasOccupancies,
  onEdit,
  onDelete,
}: Props) => {
  const { t } = useTranslate()

  return (
    <Card>
      <CardContent sx={{ padding: '4px !important' }}>
        <Stack spacing={2} direction='row' alignItems='center' justifyContent='space-between'>
          <YardNodeHeaderTitle title={name} icon={<InfiniteIcon />} />

          {focused && (
            <YardNodeHeaderEquipmentType
              yardBlockId={id}
              equipmentTypes={equipmentTypes}
              isEditable={isEditable}
            />
          )}

          {focused && isEditable && (
            <>
              <Tooltip title={t('edit', 'Edit')}>
                <IconButton onClick={() => onEdit(id)}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              {!hasOccupancies && (
                <Tooltip title={t('delete', 'Delete')}>
                  <IconButton onClick={() => onDelete(id)}>
                    <BinIcon />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}
